export default __webpack_public_path__ + "static/media/Acolyte's Gauntlets of the Earthen Prison.a9078fa3.jpg";